import styled from 'styled-components';

import { xdlColorText } from '@xing-com/tokens';

export const Wrapper = styled.div`
  display: flex;
  min-width: 100%;
  justify-content: center;
`;

export const Pagination = styled.ol`
  box-sizing: border-box;
  list-style-type: none;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 0;
`;

export const PageItem = styled.li`
  min-width: 36px;
  min-height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  cursor: pointer;
  &.activePageItem {
    background-color: ${xdlColorText};
    color: white;
    border-radius: 2px;
  }
  &.disabledPageItem {
    cursor: default;
  }
`;

export const PageLink = styled.span`
  color: ${xdlColorText};
  &:hover {
    text-decoration: none;
  }
`;
